import { useLocation, useParams } from 'react-router-dom'

import { ClaimCompanyLayout, ClaimCompanyCard } from 'components/claim/common'
import { CONFIG } from 'config'
import { SUPPLIER_CONTACT_TYPES_DISPLAY } from 'constants/supplier'
import { apply } from 'lib/styled'
import { getTokenInformation } from 'utils/getTokenInformation'

const { Image, Title, Description, Button, Field } = ClaimCompanyCard

const ClaimCompany = () => {
  const { search } = useLocation()
  const { token } = useParams()
  const { sig } = Object.fromEntries(new URLSearchParams(search))

  const { organizationName, userEmail, userContactType, companyName } =
    getTokenInformation(token)

  return (
    <ClaimCompanyLayout>
      <ClaimCompanyCard>
        <Image />
        <Title>Welcome to {organizationName} Portal</Title>
        <Description>
          Hi {userEmail}, {organizationName} has invited you as <br />{' '}
          <b>{SUPPLIER_CONTACT_TYPES_DISPLAY[userContactType]}</b> for{' '}
          <b>{companyName}</b>. To get started, please claim your company.
        </Description>
        <Field
          name="company"
          value={companyName}
          label="Company"
          id="company"
          disabled
        />
        <a
          style={apply('w-full')}
          href={`${CONFIG.API.URL}/company-claims/${token}?sig=${sig}`}
        >
          <Button>Claim Company</Button>
        </a>
      </ClaimCompanyCard>
    </ClaimCompanyLayout>
  )
}

export { ClaimCompany }
